export enum GAME_STATE{
    MAIN_MENU = 0,
    GAME = 1,
}